export const CLINIC = {
  name: "Revive Ripple",
  tagline: "Move Better, Live Better",
  phoneDisplay: "+91 84283 69740",
  phoneTel: "+918428369740",
  whatsapp: "918428369740",
  whatsappMessage:
    "Hi Revive Ripple, I'd like to book a physiotherapy session.",
  address:
    "No 25/14, Brindavan Street, Dwarka Colony, Mylapore, Chennai, Tamil Nadu 600004",
  hours: [
    { day: "Monday", time: "4:00 — 9:00 PM" },
    { day: "Tuesday", time: "4:00 — 9:00 PM" },
    { day: "Wednesday", time: "4:00 — 9:00 PM" },
    { day: "Thursday", time: "4:00 — 9:00 PM" },
    { day: "Friday", time: "4:00 — 9:00 PM" },
    { day: "Saturday", time: "4:00 — 9:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
};

export const whatsappLink = () =>
  `https://wa.me/${CLINIC.whatsapp}?text=${encodeURIComponent(
    CLINIC.whatsappMessage
  )}`;

export const telLink = () => `tel:${CLINIC.phoneTel}`;
